<template>
  <b-menu>
    <b-menu-list
      v-for="list in menu"
      :key="list.name"
      :label="list.name"
      :link="list.link"
    >
      <template v-for="item in list.items">
        <!-- If item has sub-items -->
        <b-menu-item
          v-if="Array.isArray(item.items) && item.items.length"
          :key="item.name"
          :label="item.name"
          :icon="item.icon"
          :icon-pack="item.iconPack ?? 'fas'"
          :model-value="item.active"
        >
          <b-menu-item
            v-for="subItem in item.items"
            :key="subItem.name"
            :label="subItem.name"
            :to="subItem.link"
            :tag="subItem.tag"
            :icon="subItem.icon"
            :icon-pack="subItem.iconPack ?? 'fas'"
            :model-value="subItem.active"
          />
        </b-menu-item>

        <!-- If item is just a link (no sub-items) -->
        <b-menu-item
          v-else
          :key="`simple-${item.name}`"
          :label="item.name"
          :to="item.link"
          :tag="item.tag"
          :icon="item.icon"
          :icon-pack="item.iconPack ?? 'fas'"
          :model-value="item.active"
        />
      </template>
    </b-menu-list>
  </b-menu>
</template>

<script setup lang="ts">
type MenuItem = {
  name: string;
  tag: "a" | "router-link";
  link: `/${string}` | "#";
  icon?: string;
  iconPack?: string;
  active?: boolean;
  items?: MenuItem[];
};

type Menu = {
  name: string;
  link?: `/${string}` | "#";
  items: MenuItem[];
};

defineProps<{
  menu: Menu[];
}>();
</script>
